__turbopack_context__.v({
  "en": "UiPageHead-module__QA6YXa__en",
  "head": "UiPageHead-module__QA6YXa__head",
  "lead": "UiPageHead-module__QA6YXa__lead",
  "line": "UiPageHead-module__QA6YXa__line",
  "title": "UiPageHead-module__QA6YXa__title",
});
